import { CheckCircle, Receipt, Warning, XCircle } from '@phosphor-icons/react';
import { formatCurrencyAmounts } from './helpers';

export const QuickStats = ({ stats }) => (
  <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-testid="quick-stats">
    <div className="bg-white border border-[#f2f4f6] rounded-xl p-5 hover:border-[#d6e3ff] transition-colors">
      <div className="flex items-center gap-2 mb-3">
        <div className="w-8 h-8 rounded-lg bg-[#d1fae5] flex items-center justify-center">
          <CheckCircle size={18} className="text-[#065f46]" weight="duotone" />
        </div>
        <span className="text-xs text-[#596065]">Completed</span>
      </div>
      <p className="text-2xl font-bold text-[#2d3338]" data-testid="stat-completed">{stats.tasks_completed || 0}</p>
      <p className="text-xs text-[#596065] mt-1">{stats.tasks_completed_this_month || 0} this month</p>
    </div>

    <div className="bg-white border border-[#f2f4f6] rounded-xl p-5 hover:border-[#d6e3ff] transition-colors">
      <div className="flex items-center gap-2 mb-3">
        <div className="w-8 h-8 rounded-lg bg-[#dbeafe] flex items-center justify-center">
          <Receipt size={18} className="text-[#1d4ed8]" weight="duotone" />
        </div>
        <span className="text-xs text-[#596065]">Bills Paid</span>
      </div>
      <div data-testid="stat-money-paid">
        {stats.money_paid_by_currency && Object.keys(stats.money_paid_by_currency).length > 0 ? (
          formatCurrencyAmounts(stats.money_paid_by_currency)?.map((amt, i) => (
            <p key={i} className="text-xl font-bold text-[#2d3338]">{amt}</p>
          ))
        ) : (
          <p className="text-2xl font-bold text-[#2d3338]">$0</p>
        )}
      </div>
    </div>

    <div className="bg-white border border-[#f2f4f6] rounded-xl p-5 hover:border-[#d6e3ff] transition-colors">
      <div className="flex items-center gap-2 mb-3">
        <div className="w-8 h-8 rounded-lg bg-[#fef3c7] flex items-center justify-center">
          <Warning size={18} className="text-[#92400e]" weight="duotone" />
        </div>
        <span className="text-xs text-[#596065]">Overdue</span>
      </div>
      <p className={`text-2xl font-bold ${stats.overdue_count > 0 ? 'text-[#dc2626]' : 'text-[#2d3338]'}`} data-testid="stat-overdue">
        {stats.overdue_count || 0}
      </p>
      <p className="text-xs text-[#596065] mt-1">{stats.pending_tasks || 0} pending total</p>
    </div>

    <div className="bg-white border border-[#f2f4f6] rounded-xl p-5 hover:border-[#d6e3ff] transition-colors">
      <div className="flex items-center gap-2 mb-3">
        <div className="w-8 h-8 rounded-lg bg-[#fce7f3] flex items-center justify-center">
          <XCircle size={18} className="text-[#9d174d]" weight="duotone" />
        </div>
        <span className="text-xs text-[#596065]">Subs Cancelled</span>
      </div>
      <p className="text-2xl font-bold text-[#2d3338]" data-testid="stat-cancelled">{stats.cancelled_subs || 0}</p>
      <p className="text-xs text-[#596065] mt-1">detected from email</p>
    </div>
  </div>
);
